module.exports = __webpack_public_path__ + "media/images/creator/home/about-02@3x-581355a0691096a5c6f0dd7f1b85fa39.png";